<template>
  <div id="spinner" class="spinner">
    <svg
      width="100"
      height="100"
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_11_2"
        style="mask-type: alpha"
        maskUnits="userSpaceOnUse"
        x="12"
        y="14"
        width="75"
        height="72"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M30.9548 16.75H32.5053C40.6708 17.9575 42.8845 22.5915 50 22.5915C57.1155 22.5915 59.3293 17.9575 67.4965 16.75H68.375C70.5582 16.75 72.7201 17.18 74.7371 18.0155C76.7542 18.851 78.5869 20.0756 80.1307 21.6193C81.6744 23.1631 82.899 24.9959 83.7345 27.0129C84.57 29.0299 85 31.1918 85 33.375V34.4705C85 39.5508 79.5925 45.3502 78 50.8452C76.3113 56.6797 75.1545 61.4503 74.815 66.4395C74.0188 78.1313 70.0323 83.25 65.75 83.25C59.3555 83.25 53.6785 57.0437 50.1103 57.0437C46.5403 57.0437 39.4615 83.25 34.25 83.25C31.0703 83.25 26.9525 81.3688 25.4055 66.4395C24.7895 60.5 23.75 56.8967 22 50.8452C20.46 45.5252 15.266 39.1692 15 33.4642C14.8997 31.3066 15.238 29.1511 15.9945 27.1279C16.751 25.1048 17.9101 23.2561 19.4015 21.6937C20.8929 20.1313 22.6857 18.8876 24.6715 18.0379C26.6573 17.1882 28.7948 16.75 30.9548 16.75Z"
          fill="black"
          stroke="black"
          stroke-width="4"
        />
        <path
          d="M35.0935 29.8103L64.0018 39.1308ZM35.0935 39.1308L64.0018 29.8103Z"
          fill="black"
        />
        <path
          d="M35.0935 29.8103L64.0018 39.1308M35.0935 39.1308L64.0018 29.8103"
          stroke="black"
          stroke-width="4"
          stroke-linecap="round"
        />
      </mask>
      <g mask="url(#mask0_11_2)">
        <path d="M8 8H92V92H8V8Z" fill="white" />
      </g>
    </svg>
    <p class="text">Dental</p>
  </div>
</template>

<script>
export default {
  name: "DentalLoader",
  mounted() {
    window.addEventListener("DOMContentLoaded", this.logo);
  },

  beforeUnmount() {
    window.removeEventListener("DOMContentLoaded", this.logo);
  },
  methods: {
    logo() {
      document.body.style.overflowY = "hidden";
      document.getElementById("spinner").style.cursor = "wait";
      setTimeout(() => {
        document.getElementById("spinner").style.opacity = "0";
        document.getElementById("spinner").style.visibility = "hidden";
        document.body.style.overflowY = "scroll";
        var val = window.scrollY;
        if (val > 0) {
          window.scrollTo(0, 0);
          document.getElementById("spinner").scrollTo(0, 0);
        }
      }, 4200);
    },
  },
};
</script>
